import { createFileRoute } from "@tanstack/react-router";

import { AdminOrganizationDetailPage } from "@/features/admin/organization-detail-page";
import { adminOrganizationQueryOptions } from "@/features/admin/queries";
import { organizationNameCrumb } from "@/lib/crumb-resolvers";

// ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
export const Route = createFileRoute("/_authenticated/admin/organizations/$id/")({
  staticData: { crumb: organizationNameCrumb() },
  loader: async ({ context, params }) => {
    await context.queryClient.ensureQueryData(adminOrganizationQueryOptions(params.id));
  },
  component: AdminOrganizationDetailPage,
});
